import React from 'react';
import { useTranslation } from 'react-i18next';
import { ModalContent, ModalFooter } from 'fronton-react';
import { ButtonWithGAClickButton, ModalHeader, Typography } from 'common/components';
import { css } from 'linaria';
import {
  BATHROOM_REPAIR_ELEMENT_BLOCK,
  BATHROOM_REPAIR_SIGN_UP_HREF,
} from '../../../../bathroom-repair-constants';

const modalText = css`
  &:not(:last-of-type) {
    margin-bottom: 8px;
  }
`;

type FreeProjectProps = {
  regionId: string;
};

export const FreeProjectModal = ({ regionId }: FreeProjectProps) => {
  const { t } = useTranslation();

  return (
    <>
      <ModalHeader title={t('utp-section.free-project.card-title')} />
      <ModalContent>
        <Typography variant="m" size="body_long" className={modalText}>
          {t('utp-section.free-project.modal-description-first')}
        </Typography>
        <Typography variant="m" size="body_long" className={modalText}>
          {t('utp-section.free-project.modal-description-second')}
        </Typography>
        <Typography variant="m" size="body_long" className={modalText}>
          {t('utp-section.free-project.modal-description-third')}
        </Typography>
      </ModalContent>
      <ModalFooter>
        <ButtonWithGAClickButton
          adaptive={false}
          elementBlock={BATHROOM_REPAIR_ELEMENT_BLOCK}
          elementName={`${t('utp-section.free-project.card-title')} / modal`}
          elementText={t('utp-section.modal-button')}
          href={`${BATHROOM_REPAIR_SIGN_UP_HREF}${regionId}`}
          target="_blank"
          wide>
          {t('utp-section.modal-button')}
        </ButtonWithGAClickButton>
      </ModalFooter>
    </>
  );
};
